import React, { forwardRef } from 'react';
import cn from 'classnames';
import { useHistory } from 'react-router-dom';
import { scroller } from 'react-scroll';

import { ReactComponent as SnTelegram } from '../../../images/sn_icon_telegram.svg';
import { ReactComponent as SnWhatsup } from '../../../images/sn_icon_whatsapp.svg';
import FormContactUs from '../../FormContactUs';
import { getPhone } from '../../../utils/getPhone';
import Logo from '../../Logo';

import style from './Footer.module.css';
import { CONTACTS, FOOTER_MENU_ITEMS, ID_SECTION } from './../../../store/constants';

interface Props {
  isOtherPage?: boolean;
  dark?: boolean;
}
const Footer = ({ isOtherPage, dark = false }: Props) => {
  const { PHONE, PHONE_NORMILIZE } = getPhone();

  const history = useHistory();
  function scroll(to: string): void {
    if (isOtherPage) {
      sessionStorage.setItem('mobileScrollTo', to);
      history.push({
        pathname: '/',
        state: { scrollTo: to },
      });
    } else {
      scroller.scrollTo(to, {
        duration: 800,
        smooth: true,
        offset: 0,
      });
    }
  }
  function scrollToTop(): void {
    scroll(ID_SECTION.MAIN.to);
  }
  return (
    <footer className={cn(style.footer, { dark })}>
      <FormContactUs className={style.form} />
      <div className={style.container}>
        <ul className={style.list}>
          <li className={style.logoContainer}>
            <Logo dark={dark} onClick={scrollToTop} className={style.logo} />
          </li>
          <li>
            <div className={style.item}>
              <p className={style.title}>Контакты</p>
              <a href={`tel:${PHONE_NORMILIZE}`} className={style.link} aria-label="телефон">
                {PHONE}
              </a>
              <a href={`mailto:${CONTACTS.MAIL}`} className={style.link} aria-label="Наша почта">
                {CONTACTS.MAIL}
              </a>
              <div className={style.icons}>
                <a
                  href={`https://t.me/${CONTACTS.TELEGRAM_NICK}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Наш Telegram канал"
                >
                  <SnTelegram />
                </a>
                <a
                  href={`https://wa.me/${PHONE_NORMILIZE}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Наш Whatsup"
                >
                  <SnWhatsup />
                </a>
              </div>
            </div>
            <div className={style.item}>
              <p className={style.title}>Офис</p>
              <div>{CONTACTS.ADRESS}</div>
            </div>
          </li>
          <li>
            <p className={style.title}>Навигация</p>
            <ul>
              {FOOTER_MENU_ITEMS.map(item => {
                return (
                  <li key={`Footer_${item.to}`} onClick={() => scroll(item.to)} style={{ cursor: 'pointer' }}>
                    {item.label}
                  </li>
                );
              })}
            </ul>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
